<template>
  <div>
    <el-dialog
      title="标题"
      :visible="titleMixShow"
      width="1000px"
      @close="close"
      @open="openInit"
      append-to-body
    >
      <div class="localsList mix-wrap-title">
        <p class="batch-p">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <emoji-input
            palce="标题：广告标题"
            type="text"
            v-model="comVal"
          ></emoji-input>
        </p>
        <el-checkbox-group
          v-model="checkedDatas"
          @click.stop=""
          @change="
            (val) => handleCheckedDatasChange('title', titleMsgList, val)
          "
        >
          <el-checkbox v-for="item in dataList" :label="item.id" :key="item.id">
            <span class="mixName">{{ item.name }}</span>
            <emoji-input
              palce="标题：广告标题"
              type="text"
              v-model="item.title"
            ></emoji-input>
          </el-checkbox>
        </el-checkbox-group>
        <!-- <el-row :gutter="10" v-for="item in dataList" :key="item.id">
          <el-col :span="6" style="line-height: 40px">
            <span class="mixName">{{ item.name }}</span>
          </el-col>
          <el-col :span="18">
            <emoji-input
              palce="标题：广告标题"
              type="text"
              v-model="item.title"
            ></emoji-input>
          </el-col>
        </el-row> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import emojiInput from "../../../createAd/components/emojiInput";
import mixBatchOperate from "@/views/adManagement/assets/js/mixBatchOperate";
export default {
  mixins: [mixBatchOperate],
  props: ["titleMixShow", "titleMsgList"],
  data() {
    return {
      dataList: JSON.parse(JSON.stringify(this.titleMsgList)),
    };
  },
  components: {
    emojiInput,
  },
  methods: {
    close() {
      this.backToInit(this.titleMsgList);
      this.$emit("update:titleMixShow", false);
    },
    openInit() {},
    sure() {
      if (this.dataList.some((v) => !v.title)) {
        this.$message({
          type: "warning",
          message: "行动号召不能为空",
        });
        return false;
      }
      this.$emit("setMixMsg", "title", this.dataList);
      this.close();
    },
  },
  watch: {
    titleMsgList: {
      handler() {
        this.dataList = JSON.parse(JSON.stringify(this.titleMsgList));
      },
    },
    comVal: {
      handler(val) {
        this.batchChange("title", val);
      },
    },
  },
};
</script>
<style lang="scss" scope>
.localsList {
  max-height: 700px;
  overflow-x: hidden;
  overflow-y: auto;
  .el-row {
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.mix-wrap-title {
  .batch-p {
    display: flex;
    align-items: center;
    .emojiInputWrap {
      margin-left: 10px;
      width: 100%;
    }
  }
  .el-checkbox-group {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    .el-checkbox {
      width: 100%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
    }
    .el-checkbox__label {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .mixName {
      width: 300px;
    }
    .emojiInputWrap {
      flex: 1;
    }
  }
}
</style>